"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipQuestion = exports.Chip = void 0;
const merlin_chip_1 = require("@travelnest/merlin.chip");
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ChipQuestion_1 = require("./ChipQuestion");
Object.defineProperty(exports, "ChipQuestion", { enumerable: true, get: function () { return ChipQuestion_1.ChipQuestion; } });
const ChipWrapper = styled_1.default.div `
	/* Centres text correctly as we're using a different font size to Merlin default */
	span.chip_content {
		line-height: 35px;
	}
`;
const Chip = (props) => {
    return React.createElement(ChipWrapper, { id: props.id },
        React.createElement(merlin_chip_1.Chip, Object.assign({}, props)));
};
exports.Chip = Chip;
//# sourceMappingURL=Chip.js.map